/* md5: 0edc4e3a982bbc926f7b74620e38caa8 */
/* 仓库id: 241245 */
/* 版本: 0.0.1-beta.0 */
/* eslint-disable */
/* tslint:disable */

/**
 * 本文件由接口平台自动生成，请勿修改
 * 仓库地址: http://gitee/repository/editor?id=241245
 */
import axios from '@/plugins/axios'
import { downLoad } from '@/utils'
import {
  getlistApplication,
  postaddApplication,
  postaddApplicationObject,
  deletedeleteApplicationObject,
  puteditApplicationExplain,
  putendAndArchive,
  putrevokeApplication,
  deletedeleteApplication,
  getlistApplicationObject,
  getlistReportRequest,
  putpublishReportRequest,
  posteditReportRequest,
  getgetApplication,
  getlistReportProjectList,
  getlistIndividualProjectSignUp,
  postaddToReportList,
  postremoveFormReportList,
  postsubmitReportList,
  postbatchAddOpinion,
  postbatchGradingProject,
  postconfirmFinalResult,
  getexportReportList,
  postreturnToModify,
  postsupplementJoinScope,
  getlistOrgApplication,
  getgetReportRequest,
  getgetSubAndJoinOrgList,
  getgetReportListInfo,
  getlistReportList,
  getpreAddApplication,
  postsortReportListItem,
  getlistSubReportList,
  putupdateApplication,
  getlistApplicationJoinScope,
  getgetSubRequestIsPublish,
  getgetApplicationObject,
  postsortApplicationObject,
  postrevokePublishReportRequest,
  getlistSubReportProjectList,
  putunlockApplication,
  getgetSignUpId,
  putupdateSummaryDescription,
  postgetTree,
  getgetBasicForm
} from './model'
import {ValidateType} from './model/utils'
const isPod = process.env.NODE_ENV === 'production'

let validatelistApplication = new ValidateType(getlistApplication.Req, 'api-general/api-general/module/selection/application/listApplication', 'GET')
export function listApplication (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatelistApplication.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/listApplication',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateaddApplication = new ValidateType(postaddApplication.Req, 'api-general/api-general/module/selection/application/addApplication', 'POST')
export function addApplication (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateaddApplication.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/addApplication',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateaddApplicationObject = new ValidateType(postaddApplicationObject.Req, 'api-general/api-general/module/selection/application/addApplicationObject', 'POST')
export function addApplicationObject (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateaddApplicationObject.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/addApplicationObject',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatedeleteApplicationObject = new ValidateType(deletedeleteApplicationObject.Req, 'api-general/api-general/module/selection/application/deleteApplicationObject', 'DELETE')
export function deleteApplicationObject (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatedeleteApplicationObject.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/deleteApplicationObject',
    method: 'DELETE',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateeditApplicationExplain = new ValidateType(puteditApplicationExplain.Req, 'api-general/api-general/module/selection/application/editApplicationExplain', 'PUT')
export function editApplicationExplain (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateeditApplicationExplain.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/editApplicationExplain',
    method: 'PUT',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateendAndArchive = new ValidateType(putendAndArchive.Req, 'api-general/api-general/module/selection/application/endAndArchive', 'PUT')
export function endAndArchive (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateendAndArchive.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/endAndArchive',
    method: 'PUT',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validaterevokeApplication = new ValidateType(putrevokeApplication.Req, 'api-general/api-general/module/selection/application/revokeApplication', 'PUT')
export function revokeApplication (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validaterevokeApplication.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/revokeApplication',
    method: 'PUT',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatedeleteApplication = new ValidateType(deletedeleteApplication.Req, 'api-general/api-general/module/selection/application/deleteApplication', 'DELETE')
export function deleteApplication (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatedeleteApplication.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/deleteApplication',
    method: 'DELETE',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatelistApplicationObject = new ValidateType(getlistApplicationObject.Req, 'api-general/api-general/module/selection/application/listApplicationObject', 'GET')
export function listApplicationObject (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatelistApplicationObject.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/listApplicationObject',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatelistReportRequest = new ValidateType(getlistReportRequest.Req, 'api-general/api-general/module/selection/application/listReportRequest', 'GET')
export function listReportRequest (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatelistReportRequest.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/listReportRequest',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatepublishReportRequest = new ValidateType(putpublishReportRequest.Req, 'api-general/api-general/module/selection/application/publishReportRequest', 'PUT')
export function publishReportRequest (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatepublishReportRequest.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/publishReportRequest',
    method: 'PUT',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateeditReportRequest = new ValidateType(posteditReportRequest.Req, 'api-general/api-general/module/selection/application/editReportRequest', 'POST')
export function editReportRequest (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateeditReportRequest.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/editReportRequest',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validategetApplication = new ValidateType(getgetApplication.Req, 'api-general/api-general/module/selection/application/getApplication', 'GET')
export function getApplication (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validategetApplication.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/getApplication',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatelistReportProjectList = new ValidateType(getlistReportProjectList.Req, 'api-general/api-general/module/selection/application/listReportProjectList', 'GET')
export function listReportProjectList (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatelistReportProjectList.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/listReportProjectList',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatelistIndividualProjectSignUp = new ValidateType(getlistIndividualProjectSignUp.Req, 'api-general/api-general/module/selection/application/listIndividualSignUp', 'GET')
export function listIndividualProjectSignUp (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatelistIndividualProjectSignUp.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/listIndividualSignUp',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateaddToReportList = new ValidateType(postaddToReportList.Req, 'api-general/api-general/module/selection/application/addToReportList', 'POST')
export function addToReportList (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateaddToReportList.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/addToReportList',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateremoveFormReportList = new ValidateType(postremoveFormReportList.Req, 'api-general/api-general/module/selection/application/removeFormReportList', 'POST')
export function removeFormReportList (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateremoveFormReportList.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/removeFormReportList',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatesubmitReportList = new ValidateType(postsubmitReportList.Req, 'api-general/api-general/module/selection/application/submitReportList', 'POST')
export function submitReportList (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatesubmitReportList.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/submitReportList',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatebatchAddOpinion = new ValidateType(postbatchAddOpinion.Req, 'api-general/api-general/module/selection/application/batchAddOpinion', 'POST')
export function batchAddOpinion (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatebatchAddOpinion.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/batchAddOpinion',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatebatchGradingProject = new ValidateType(postbatchGradingProject.Req, 'api-general/api-general/module/selection/application/batchGradingProject', 'POST')
export function batchGradingProject (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatebatchGradingProject.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/batchGradingProject',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateconfirmFinalResult = new ValidateType(postconfirmFinalResult.Req, 'api-general/api-general/module/selection/application/confirmFinalResult', 'POST')
export function confirmFinalResult (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateconfirmFinalResult.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/confirmFinalResult',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateexportReportList = new ValidateType(getexportReportList.Req, 'api-general/api-general/module/selection/application/exportReportList', 'GET')
export function exportReportList (req, config = {}, filterKey = []) {
  downLoad('/api-general/module/selection/application/exportReportList', req)
}

let validatereturnToModify = new ValidateType(postreturnToModify.Req, 'api-general/api-general/module/selection/application/returnToModify', 'POST')
export function returnToModify (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatereturnToModify.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/returnToModify',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatesupplementJoinScope = new ValidateType(postsupplementJoinScope.Req, 'api-general/api-general/module/selection/application/supplementJoinScope', 'POST')
export function supplementJoinScope (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatesupplementJoinScope.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/supplementJoinScope',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatelistOrgApplication = new ValidateType(getlistOrgApplication.Req, 'api-general/api-general/module/selection/application/listOrgApplication', 'GET')
export function listOrgApplication (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatelistOrgApplication.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/listOrgApplication',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validategetReportRequest = new ValidateType(getgetReportRequest.Req, 'api-general/api-general/module/selection/application/getReportRequest', 'GET')
export function getReportRequest (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validategetReportRequest.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/getReportRequest',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validategetSubAndJoinOrgList = new ValidateType(getgetSubAndJoinOrgList.Req, 'api-general/api-general/module/selection/application/getSubAndJoinOrgList', 'GET')
export function getSubAndJoinOrgList (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validategetSubAndJoinOrgList.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/getSubAndJoinOrgList',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validategetReportListInfo = new ValidateType(getgetReportListInfo.Req, 'api-general/api-general/module/selection/application/getReportListInfo', 'GET')
export function getReportListInfo (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validategetReportListInfo.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/getReportListInfo',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatelistReportList = new ValidateType(getlistReportList.Req, 'api-general/api-general/module/selection/application/listReportList', 'GET')
export function listReportList (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatelistReportList.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/listReportList',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatepreAddApplication = new ValidateType(getpreAddApplication.Req, 'api-general/api-general/module/selection/application/preAddApplication', 'GET')
export function preAddApplication (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatepreAddApplication.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/preAddApplication',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatesortReportListItem = new ValidateType(postsortReportListItem.Req, 'api-general/api-general/module/selection/application/sortReportListItem', 'POST')
export function sortReportListItem (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatesortReportListItem.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/sortReportListItem',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatelistSubReportList = new ValidateType(getlistSubReportList.Req, 'api-general/api-general/module/selection/application/listSubReportList', 'GET')
export function listSubReportList (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatelistSubReportList.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/listSubReportList',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateupdateApplication = new ValidateType(putupdateApplication.Req, 'api-general/api-general/module/selection/application/updateApplication', 'PUT')
export function updateApplication (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateupdateApplication.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/updateApplication',
    method: 'PUT',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatelistApplicationJoinScope = new ValidateType(getlistApplicationJoinScope.Req, 'api-general/api-general/module/selection/application/listApplicationJoinScope', 'GET')
export function listApplicationJoinScope (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatelistApplicationJoinScope.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/listApplicationJoinScope',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validategetSubRequestIsPublish = new ValidateType(getgetSubRequestIsPublish.Req, 'api-general/api-general/module/selection/application/getSubRequestIsPublish', 'GET')
export function getSubRequestIsPublish (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validategetSubRequestIsPublish.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/getSubRequestIsPublish',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validategetApplicationObject = new ValidateType(getgetApplicationObject.Req, 'api-general/api-general/module/selection/application/getApplicationObject', 'GET')
export function getApplicationObject (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validategetApplicationObject.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/getApplicationObject',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatesortApplicationObject = new ValidateType(postsortApplicationObject.Req, 'api-general/api-general/module/selection/application/sortApplicationObject', 'POST')
export function sortApplicationObject (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatesortApplicationObject.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/sortApplicationObject',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validaterevokePublishReportRequest = new ValidateType(postrevokePublishReportRequest.Req, 'api-general/api-general/module/selection/application/revokePublishReportRequest', 'POST')
export function revokePublishReportRequest (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validaterevokePublishReportRequest.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/revokePublishReportRequest',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatelistSubReportProjectList = new ValidateType(getlistSubReportProjectList.Req, 'api-general/api-general/module/selection/application/listSubReportProjectList', 'GET')
export function listSubReportProjectList (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatelistSubReportProjectList.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/listSubReportProjectList',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateunlockApplication = new ValidateType(putunlockApplication.Req, 'api-general/api-general/module/selection/application/unlockApplication', 'PUT')
export function unlockApplication (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateunlockApplication.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/unlockApplication',
    method: 'PUT',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validategetSignUpId = new ValidateType(getgetSignUpId.Req, 'api-general/api-general/module/selection/personalCenter/application/getSignUpId', 'GET')
export function getSignUpId (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validategetSignUpId.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/personalCenter/application/getSignUpId',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateupdateSummaryDescription = new ValidateType(putupdateSummaryDescription.Req, 'api-general/api-general/module/selection/application/updateSummaryDescription', 'PUT')
export function updateSummaryDescription (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateupdateSummaryDescription.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/updateSummaryDescription',
    method: 'PUT',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validategetTree = new ValidateType(postgetTree.Req, 'api-general/api-general/module/selection/application/getTree', 'POST')
export function getTree (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validategetTree.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/getTree',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validategetBasicForm = new ValidateType(getgetBasicForm.Req, 'api-general/api-general/module/selection/application/getBasicForm', 'GET')
export function getBasicForm (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validategetBasicForm.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/api-general/module/selection/application/getBasicForm',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}